import React from 'react'
import { useConnect } from 'sb-redux-hook'

import NavListView from './NavListView/NavListView'
import type { NavListViewProps } from './NavListView/NavListView'


export type NavListProps = {
  items: NavListViewProps['items']
  minSubNavLengthToDisplay?: number
  closeNav: () => void
}

const NavList: React.FunctionComponent<NavListProps> = (props) => {
  const { pathname, search } = useConnect({
    pathname: 'routing.location.pathname',
    search: 'routing.location.search',
  })

  return (
    <NavListView
      {...props}
      pathname={pathname}
      search={search}
    />
  )
}


export default React.memo(NavList)
